import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';

import CONFIG from './config';

export const LinkLikeButtonDefaultProps = {
  ...ChildrenDefaultProps,
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  buttonSize: null,
  context: null,
  display: null,
  external: false,
  onClick: () => null,
  variant: null,
};

export const LinkLikeButtonPropTypes = {
  ...ChildrenPropTypes,
  ...ClassNamePropTypes,
  ...DisabledPropTypes,
  buttonSize: PropTypes.oneOfType([
    PropTypes.oneOf(Object.values(CONFIG.size)),
    PropTypes.oneOf([null]),
  ]),
  context: PropTypes.string,
  display: PropTypes.string,
  external: PropTypes.bool,
  onClick: PropTypes.func,
  url: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(Object.values(CONFIG.variant)),
    PropTypes.oneOf([null]),
  ]),
};
